import "react-datepicker/dist/react-datepicker.css";

import { store } from "../../..";
import "../../../assets/css/majorybl/pages/clubhouse.scss";
import { globalActions } from "../../../features/global/globalSlice";
import {
    leagueManagementActions,
    selectSelectedLeague,
} from "../../../features/leaguemgmt/leagueManagementSlice";
import { getLeagueSchedule } from "../../../lib/api";

const rescheduleGameLeagueManagementLoader = async ({ params }: any) => {
    const { gameId } = params;
    const leagueId = parseInt(params.leagueId);

    const settings = store.getState().global.settings;
    const leagues = store.getState().leaguemanagement.leagues;
    const fields = store.getState().global.fields;
    const promises = [];

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !leagues.length &&
        promises.push(store.dispatch(leagueManagementActions.getLeagues()));
    !fields.length && promises.push(store.dispatch(globalActions.getFields()));

    const [{ schedule }] = await Promise.all([
        getLeagueSchedule(leagueId),
        ...promises,
    ]);

    store.dispatch(leagueManagementActions.setSelectedLeague(leagueId));
    const league = selectSelectedLeague(store.getState());

    const game = schedule.games?.find(g => g.id === parseInt(gameId));

    const header = `${league?.ageLevel}${league?.designation ? ` ${league?.designation}` : ""}${league?.direction ? ` ${league?.direction}` : ""} - Reschedule ${game?.visitor.name || "TBD"} @ ${game?.home.name || "TBD"}`;

    return {
        leagueId,
        header,
        gameId: parseInt(gameId),
    };
};

export default rescheduleGameLeagueManagementLoader;
